"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/events/EventType
 */

/**
 * @enum {string}
 * @const
 */
var _default = {
  /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */
  CHANGE: 'change',

  /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */
  ERROR: 'error',
  BLUR: 'blur',
  CLEAR: 'clear',
  CONTEXTMENU: 'contextmenu',
  CLICK: 'click',
  DBLCLICK: 'dblclick',
  DRAGENTER: 'dragenter',
  DRAGOVER: 'dragover',
  DROP: 'drop',
  FOCUS: 'focus',
  KEYDOWN: 'keydown',
  KEYPRESS: 'keypress',
  LOAD: 'load',
  RESIZE: 'resize',
  TOUCHMOVE: 'touchmove',
  WHEEL: 'wheel'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7ZUFJZTtFQUNiOzs7OztFQUtBQSxNQUFNLEVBQUUsUUFOSzs7RUFRYjs7Ozs7RUFLQUMsS0FBSyxFQUFFLE9BYk07RUFlYkMsSUFBSSxFQUFFLE1BZk87RUFnQmJDLEtBQUssRUFBRSxPQWhCTTtFQWlCYkMsV0FBVyxFQUFFLGFBakJBO0VBa0JiQyxLQUFLLEVBQUUsT0FsQk07RUFtQmJDLFFBQVEsRUFBRSxVQW5CRztFQW9CYkMsU0FBUyxFQUFFLFdBcEJFO0VBcUJiQyxRQUFRLEVBQUUsVUFyQkc7RUFzQmJDLElBQUksRUFBRSxNQXRCTztFQXVCYkMsS0FBSyxFQUFFLE9BdkJNO0VBd0JiQyxPQUFPLEVBQUUsU0F4Qkk7RUF5QmJDLFFBQVEsRUFBRSxVQXpCRztFQTBCYkMsSUFBSSxFQUFFLE1BMUJPO0VBMkJiQyxNQUFNLEVBQUUsUUEzQks7RUE0QmJDLFNBQVMsRUFBRSxXQTVCRTtFQTZCYkMsS0FBSyxFQUFFO0FBN0JNLEMiLCJuYW1lcyI6WyJDSEFOR0UiLCJFUlJPUiIsIkJMVVIiLCJDTEVBUiIsIkNPTlRFWFRNRU5VIiwiQ0xJQ0siLCJEQkxDTElDSyIsIkRSQUdFTlRFUiIsIkRSQUdPVkVSIiwiRFJPUCIsIkZPQ1VTIiwiS0VZRE9XTiIsIktFWVBSRVNTIiwiTE9BRCIsIlJFU0laRSIsIlRPVUNITU9WRSIsIldIRUVMIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ldmVudHMvRXZlbnRUeXBlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19